$(document).ready(function () {
    // Search will hide/show relevant outcomes
    $('#searchterm').keyup(function () {
        var value = $(this).val();
        if (value === '') {
            $('div.checkbox').show();
        } else {
            $('div.checkbox').each(function () {
                if ($(this).find('span').text().search(new RegExp(value, 'i')) < 0) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        }
    });
});
